





















import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import ChatMessage from '@/components/Chat/ChatMessage.vue'
import {ChatStatus} from '@/entities/chat'
import {ConvUIQuestions} from '@/pages/dashboard/entities/dash'
import { UserDetail } from '@/entities/user'


@Component<ChatMessages>({
    components: {ChatMessage}
})
export default class ChatMessages extends Vue {
    @Prop({type: Array, default: []}) public messages!: ChatMessage[]
    @Prop(Function) public onChangeReplyReview
    @Prop(Object) public chatStatus !: ChatStatus
    @Prop(Object) public customData!: {}
    @Prop(Object) public person!: UserDetail
    @Prop(Boolean) public canDeleteNote!: boolean
    @Prop(Boolean) public isUserBasic!: boolean
    @Prop({ type: Boolean, default: false }) public noPad!: boolean
    @Prop() public convQuestions!: ConvUIQuestions
    @Prop(Boolean)
    hasNetworkConnection!:boolean

    @Watch('messages')
    onMessagesChanged() { this.scrollToBottom() }

    public generateMessageKey(message) {
        return message.type + (message.id ?? message.notice_id)
    }

    public scrollToBottom() {
        this.$nextTick(() => { // Avoiding animation/load weirdness
            const messageElements = this.$refs.messageElements

            if(Array.isArray(messageElements) && messageElements.length) { // Avoiding multitype complaints
                (messageElements[messageElements.length-1] as Vue).$el.scrollIntoView()
            }
        })
    }
}
